export const fullNavbarWidth = '220px';
export const miniNavbarWidth = '56px';
export const navbarHeight = '50px';
